module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAXUlEQVQoFZXBsQ0DQRDEMKn/oscKNrjoAZPyJ/mTnIUPhshZ+GCInIUYHgsxRM5CDI+FGCJnIYbHQgyRsxDDYyGGyFmI4bEQQ+QsxPBYiCFyFj4YImfhgyHyJ/nTDxhgQA+z9efuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_00.png
// module id = 222
// module chunks = 0